import React from "react"

const Logo = () => {
  return (
    <div className="logo">
      <img
        className="logo-icon"
        src="/images/Logo/digiwall-logo.svg"
        alt="DigiWall Logo"
      />
      <span className="logo-text">DigiWall</span>
    </div>
  )
}

export default Logo
